export const googleConfig = {
  clientId:
    "252255479301-dqde4qidudcsjsrn6811rjoat8cap2i3.apps.googleusercontent.com",
  scopes: ["openid", "email", "profile"],
  redirectUri: window.location.href.toLowerCase(),
};

// Initialize Google Identity Services with One Tap support
export const initializeGoogleAuth = (callback: (response: any) => void) => {
  return new Promise<void>((resolve) => {
    if (window.google) {
      window.google.accounts.id.initialize({
        client_id: googleConfig.clientId,
        callback: (response: any) => {
          callback(response);
        },
        auto_select: false,
        cancel_on_tap_outside: true,
        prompt_parent_id: "g_id_onload",
        use_fedcm_for_prompt: true,
      });
      resolve();
    } else {
      // Load Google Identity Services script if not already loaded
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      script.onload = () => {
        window.google.accounts.id.initialize({
          client_id: googleConfig.clientId,
          callback: (response: any) => {
            callback(response);
          },
          auto_select: false,
          cancel_on_tap_outside: true,
        });
        resolve();
      };
      document.head.appendChild(script);
    }
  });
};

// Extend Window interface to include Google Identity Services
declare global {
  interface Window {
    google: {
      accounts: {
        id: {
          initialize: (config: any) => void;
          prompt: (callback?: (notification: any) => void) => void;
          renderButton: (element: HTMLElement, options: any) => void;
          disableAutoSelect: () => void;
          storeCredential: (credential: any, callback?: () => void) => void;
          cancel: () => void;
          revoke: (hint: string, callback?: () => void) => void;
          // One Tap specific methods
          display: (display: "one_tap" | "popup" | "inline") => void;
        };
        oauth2: {
          initTokenClient: (config: any) => any;
          hasGrantedAllScopes: (
            tokenResponse: any,
            ...scopes: string[]
          ) => boolean;
          hasGrantedAnyScope: (
            tokenResponse: any,
            ...scopes: string[]
          ) => boolean;
          revoke: (accessToken: string, callback?: () => void) => void;
        };
      };
    };
  }
}
